[
  {
    "timeZone": "Pacific/Midway",
    "offsetDescription": "GMT-11:00",
    "offsetInText": "-11:00",
    "offsetInSeconds": -39600,
    "offsetInMinutes": -660,
    "countryIsoCode": "UM",
    "country": "United States Minor Outlying Islands",
    "location": "Midway"
  },
  {
    "timeZone": "Pacific/Niue",
    "offsetDescription": "GMT-11:00",
    "offsetInText": "-11:00",
    "offsetInSeconds": -39600,
    "offsetInMinutes": -660,
    "countryIsoCode": "NU",
    "country": "Niue",
    "location": "Niue"
  },
  {
    "timeZone": "Pacific/Pago_Pago",
    "offsetDescription": "GMT-11:00",
    "offsetInText": "-11:00",
    "offsetInSeconds": -39600,
    "offsetInMinutes": -660,
    "countryIsoCode": "AS",
    "country": "American Samoa",
    "location": "Pago_Pago"
  },
  {
    "timeZone": "America/Adak",
    "offsetDescription": "GMT-10:00",
    "offsetInText": "-10:00",
    "offsetInSeconds": -36000,
    "offsetInMinutes": -600,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Adak"
  },
  {
    "timeZone": "Pacific/Honolulu",
    "offsetDescription": "GMT-10:00",
    "offsetInText": "-10:00",
    "offsetInSeconds": -36000,
    "offsetInMinutes": -600,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Honolulu"
  },
  {
    "timeZone": "Pacific/Rarotonga",
    "offsetDescription": "GMT-10:00",
    "offsetInText": "-10:00",
    "offsetInSeconds": -36000,
    "offsetInMinutes": -600,
    "countryIsoCode": "CK",
    "country": "Cook Islands",
    "location": "Rarotonga"
  },
  {
    "timeZone": "Pacific/Tahiti",
    "offsetDescription": "GMT-10:00",
    "offsetInText": "-10:00",
    "offsetInSeconds": -36000,
    "offsetInMinutes": -600,
    "countryIsoCode": "PF",
    "country": "French Polynesia",
    "location": "Tahiti"
  },
  {
    "timeZone": "Pacific/Marquesas",
    "offsetDescription": "GMT-09:30",
    "offsetInText": "-09:30",
    "offsetInSeconds": -34200,
    "offsetInMinutes": -570,
    "countryIsoCode": "PF",
    "country": "French Polynesia",
    "location": "Marquesas"
  },
  {
    "timeZone": "America/Anchorage",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Anchorage"
  },
  {
    "timeZone": "America/Juneau",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Juneau"
  },
  {
    "timeZone": "America/Metlakatla",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Metlakatla"
  },
  {
    "timeZone": "America/Nome",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Nome"
  },
  {
    "timeZone": "America/Sitka",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Sitka"
  },
  {
    "timeZone": "America/Yakutat",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Yakutat"
  },
  {
    "timeZone": "Pacific/Gambier",
    "offsetDescription": "GMT-09:00",
    "offsetInText": "-09:00",
    "offsetInSeconds": -32400,
    "offsetInMinutes": -540,
    "countryIsoCode": "PF",
    "country": "French Polynesia",
    "location": "Gambier"
  },
  {
    "timeZone": "America/Los_Angeles",
    "offsetDescription": "GMT-08:00",
    "offsetInText": "-08:00",
    "offsetInSeconds": -28800,
    "offsetInMinutes": -480,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Los_Angeles"
  },
  {
    "timeZone": "America/Tijuana",
    "offsetDescription": "GMT-08:00",
    "offsetInText": "-08:00",
    "offsetInSeconds": -28800,
    "offsetInMinutes": -480,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Tijuana"
  },
  {
    "timeZone": "America/Vancouver",
    "offsetDescription": "GMT-08:00",
    "offsetInText": "-08:00",
    "offsetInSeconds": -28800,
    "offsetInMinutes": -480,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Vancouver"
  },
  {
    "timeZone": "Pacific/Pitcairn",
    "offsetDescription": "GMT-08:00",
    "offsetInText": "-08:00",
    "offsetInSeconds": -28800,
    "offsetInMinutes": -480,
    "countryIsoCode": "PN",
    "country": "Pitcairn",
    "location": "Pitcairn"
  },
  {
    "timeZone": "America/Boise",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Boise"
  },
  {
    "timeZone": "America/Cambridge_Bay",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Cambridge_Bay"
  },
  {
    "timeZone": "America/Ciudad_Juarez",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Ciudad_Juarez"
  },
  {
    "timeZone": "America/Creston",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Creston"
  },
  {
    "timeZone": "America/Dawson",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Dawson"
  },
  {
    "timeZone": "America/Dawson_Creek",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Dawson_Creek"
  },
  {
    "timeZone": "America/Denver",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Denver"
  },
  {
    "timeZone": "America/Edmonton",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Edmonton"
  },
  {
    "timeZone": "America/Fort_Nelson",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Fort_Nelson"
  },
  {
    "timeZone": "America/Hermosillo",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Hermosillo"
  },
  {
    "timeZone": "America/Inuvik",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Inuvik"
  },
  {
    "timeZone": "America/Mazatlan",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Mazatlan"
  },
  {
    "timeZone": "America/Phoenix",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Phoenix"
  },
  {
    "timeZone": "America/Whitehorse",
    "offsetDescription": "GMT-07:00",
    "offsetInText": "-07:00",
    "offsetInSeconds": -25200,
    "offsetInMinutes": -420,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Whitehorse"
  },
  {
    "timeZone": "America/Bahia_Banderas",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Bahia_Banderas"
  },
  {
    "timeZone": "America/Belize",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "BZ",
    "country": "Belize",
    "location": "Belize"
  },
  {
    "timeZone": "America/Chicago",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Chicago"
  },
  {
    "timeZone": "America/Chihuahua",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Chihuahua"
  },
  {
    "timeZone": "America/Costa_Rica",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CR",
    "country": "Costa Rica",
    "location": "Costa_Rica"
  },
  {
    "timeZone": "America/El_Salvador",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "SV",
    "country": "El Salvador",
    "location": "El_Salvador"
  },
  {
    "timeZone": "America/Guatemala",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "GT",
    "country": "Guatemala",
    "location": "Guatemala"
  },
  {
    "timeZone": "America/Indiana/Knox",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Knox"
  },
  {
    "timeZone": "America/Indiana/Tell_City",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Tell_City"
  },
  {
    "timeZone": "America/Managua",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "NI",
    "country": "Nicaragua",
    "location": "Managua"
  },
  {
    "timeZone": "America/Matamoros",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Matamoros"
  },
  {
    "timeZone": "America/Menominee",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Menominee"
  },
  {
    "timeZone": "America/Merida",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Merida"
  },
  {
    "timeZone": "America/Mexico_City",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Mexico_City"
  },
  {
    "timeZone": "America/Monterrey",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Monterrey"
  },
  {
    "timeZone": "America/North_Dakota/Beulah",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Beulah"
  },
  {
    "timeZone": "America/North_Dakota/Center",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Center"
  },
  {
    "timeZone": "America/North_Dakota/New_Salem",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "New_Salem"
  },
  {
    "timeZone": "America/Ojinaga",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Ojinaga"
  },
  {
    "timeZone": "America/Rankin_Inlet",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Rankin_Inlet"
  },
  {
    "timeZone": "America/Regina",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Regina"
  },
  {
    "timeZone": "America/Resolute",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Resolute"
  },
  {
    "timeZone": "America/Swift_Current",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Swift_Current"
  },
  {
    "timeZone": "America/Tegucigalpa",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "HN",
    "country": "Honduras",
    "location": "Tegucigalpa"
  },
  {
    "timeZone": "America/Winnipeg",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Winnipeg"
  },
  {
    "timeZone": "Pacific/Galapagos",
    "offsetDescription": "GMT-06:00",
    "offsetInText": "-06:00",
    "offsetInSeconds": -21600,
    "offsetInMinutes": -360,
    "countryIsoCode": "EC",
    "country": "Ecuador",
    "location": "Galapagos"
  },
  {
    "timeZone": "America/Atikokan",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Atikokan"
  },
  {
    "timeZone": "America/Bogota",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CO",
    "country": "Colombia",
    "location": "Bogota"
  },
  {
    "timeZone": "America/Cancun",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "MX",
    "country": "Mexico",
    "location": "Cancun"
  },
  {
    "timeZone": "America/Cayman",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "KY",
    "country": "Cayman Islands",
    "location": "Cayman"
  },
  {
    "timeZone": "America/Detroit",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Detroit"
  },
  {
    "timeZone": "America/Eirunepe",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Eirunepe"
  },
  {
    "timeZone": "America/Grand_Turk",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "TC",
    "country": "Turks and Caicos Islands",
    "location": "Grand_Turk"
  },
  {
    "timeZone": "America/Guayaquil",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "EC",
    "country": "Ecuador",
    "location": "Guayaquil"
  },
  {
    "timeZone": "America/Havana",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CU",
    "country": "Cuba",
    "location": "Havana"
  },
  {
    "timeZone": "America/Indiana/Indianapolis",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Indianapolis"
  },
  {
    "timeZone": "America/Indiana/Marengo",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Marengo"
  },
  {
    "timeZone": "America/Indiana/Petersburg",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Petersburg"
  },
  {
    "timeZone": "America/Indiana/Vevay",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Vevay"
  },
  {
    "timeZone": "America/Indiana/Vincennes",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Vincennes"
  },
  {
    "timeZone": "America/Indiana/Winamac",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Winamac"
  },
  {
    "timeZone": "America/Iqaluit",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Iqaluit"
  },
  {
    "timeZone": "America/Jamaica",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "JM",
    "country": "Jamaica",
    "location": "Jamaica"
  },
  {
    "timeZone": "America/Kentucky/Louisville",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Louisville"
  },
  {
    "timeZone": "America/Kentucky/Monticello",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "Monticello"
  },
  {
    "timeZone": "America/Lima",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "PE",
    "country": "Peru",
    "location": "Lima"
  },
  {
    "timeZone": "America/Nassau",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "BS",
    "country": "Bahamas",
    "location": "Nassau"
  },
  {
    "timeZone": "America/New_York",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "US",
    "country": "United States",
    "location": "New_York"
  },
  {
    "timeZone": "America/Panama",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "PA",
    "country": "Panama",
    "location": "Panama"
  },
  {
    "timeZone": "America/Port-au-Prince",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "HT",
    "country": "Haiti",
    "location": "Port-au-Prince"
  },
  {
    "timeZone": "America/Rio_Branco",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Rio_Branco"
  },
  {
    "timeZone": "America/Toronto",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Toronto"
  },
  {
    "timeZone": "Pacific/Easter",
    "offsetDescription": "GMT-05:00",
    "offsetInText": "-05:00",
    "offsetInSeconds": -18000,
    "offsetInMinutes": -300,
    "countryIsoCode": "CL",
    "country": "Chile",
    "location": "Easter"
  },
  {
    "timeZone": "America/Anguilla",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "AI",
    "country": "Anguilla",
    "location": "Anguilla"
  },
  {
    "timeZone": "America/Antigua",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "AG",
    "country": "Antigua and Barbuda",
    "location": "Antigua"
  },
  {
    "timeZone": "America/Aruba",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "AW",
    "country": "Aruba",
    "location": "Aruba"
  },
  {
    "timeZone": "America/Barbados",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BB",
    "country": "Barbados",
    "location": "Barbados"
  },
  {
    "timeZone": "America/Blanc-Sablon",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Blanc-Sablon"
  },
  {
    "timeZone": "America/Boa_Vista",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Boa_Vista"
  },
  {
    "timeZone": "America/Campo_Grande",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Campo_Grande"
  },
  {
    "timeZone": "America/Caracas",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "VE",
    "country": "Venezuela, Bolivarian Republic of",
    "location": "Caracas"
  },
  {
    "timeZone": "America/Cuiaba",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Cuiaba"
  },
  {
    "timeZone": "America/Curacao",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CW",
    "country": "Curaçao",
    "location": "Curacao"
  },
  {
    "timeZone": "America/Dominica",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "DM",
    "country": "Dominica",
    "location": "Dominica"
  },
  {
    "timeZone": "America/Glace_Bay",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Glace_Bay"
  },
  {
    "timeZone": "America/Goose_Bay",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Goose_Bay"
  },
  {
    "timeZone": "America/Grenada",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "GD",
    "country": "Grenada",
    "location": "Grenada"
  },
  {
    "timeZone": "America/Guadeloupe",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "GP",
    "country": "Guadeloupe",
    "location": "Guadeloupe"
  },
  {
    "timeZone": "America/Guyana",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "GY",
    "country": "Guyana",
    "location": "Guyana"
  },
  {
    "timeZone": "America/Halifax",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Halifax"
  },
  {
    "timeZone": "America/Kralendijk",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BQ",
    "country": "Bonaire, Sint Eustatius and Saba",
    "location": "Kralendijk"
  },
  {
    "timeZone": "America/La_Paz",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BO",
    "country": "Bolivia, Plurinational State of",
    "location": "La_Paz"
  },
  {
    "timeZone": "America/Lower_Princes",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "SX",
    "country": "Sint Maarten (Dutch part)",
    "location": "Lower_Princes"
  },
  {
    "timeZone": "America/Manaus",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Manaus"
  },
  {
    "timeZone": "America/Marigot",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "MF",
    "country": "Saint Martin (French part)",
    "location": "Marigot"
  },
  {
    "timeZone": "America/Martinique",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "MQ",
    "country": "Martinique",
    "location": "Martinique"
  },
  {
    "timeZone": "America/Moncton",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "Moncton"
  },
  {
    "timeZone": "America/Montserrat",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "MS",
    "country": "Montserrat",
    "location": "Montserrat"
  },
  {
    "timeZone": "America/Port_of_Spain",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "TT",
    "country": "Trinidad and Tobago",
    "location": "Port_of_Spain"
  },
  {
    "timeZone": "America/Porto_Velho",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Porto_Velho"
  },
  {
    "timeZone": "America/Puerto_Rico",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "PR",
    "country": "Puerto Rico",
    "location": "Puerto_Rico"
  },
  {
    "timeZone": "America/Santo_Domingo",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "DO",
    "country": "Dominican Republic",
    "location": "Santo_Domingo"
  },
  {
    "timeZone": "America/St_Barthelemy",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BL",
    "country": "Saint Barthélemy",
    "location": "St_Barthelemy"
  },
  {
    "timeZone": "America/St_Kitts",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "KN",
    "country": "Saint Kitts and Nevis",
    "location": "St_Kitts"
  },
  {
    "timeZone": "America/St_Lucia",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "LC",
    "country": "Saint Lucia",
    "location": "St_Lucia"
  },
  {
    "timeZone": "America/St_Thomas",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "VI",
    "country": "Virgin Islands, U.S.",
    "location": "St_Thomas"
  },
  {
    "timeZone": "America/St_Vincent",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "VC",
    "country": "Saint Vincent and the Grenadines",
    "location": "St_Vincent"
  },
  {
    "timeZone": "America/Thule",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "GL",
    "country": "Greenland",
    "location": "Thule"
  },
  {
    "timeZone": "America/Tortola",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "VG",
    "country": "Virgin Islands, British",
    "location": "Tortola"
  },
  {
    "timeZone": "Atlantic/Bermuda",
    "offsetDescription": "GMT-04:00",
    "offsetInText": "-04:00",
    "offsetInSeconds": -14400,
    "offsetInMinutes": -240,
    "countryIsoCode": "BM",
    "country": "Bermuda",
    "location": "Bermuda"
  },
  {
    "timeZone": "America/St_Johns",
    "offsetDescription": "GMT-03:30",
    "offsetInText": "-03:30",
    "offsetInSeconds": -12600,
    "offsetInMinutes": -210,
    "countryIsoCode": "CA",
    "country": "Canada",
    "location": "St_Johns"
  },
  {
    "timeZone": "America/Araguaina",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Araguaina"
  },
  {
    "timeZone": "America/Argentina/Buenos_Aires",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Buenos_Aires"
  },
  {
    "timeZone": "America/Argentina/Catamarca",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Catamarca"
  },
  {
    "timeZone": "America/Argentina/Cordoba",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Cordoba"
  },
  {
    "timeZone": "America/Argentina/Jujuy",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Jujuy"
  },
  {
    "timeZone": "America/Argentina/La_Rioja",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "La_Rioja"
  },
  {
    "timeZone": "America/Argentina/Mendoza",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Mendoza"
  },
  {
    "timeZone": "America/Argentina/Rio_Gallegos",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Rio_Gallegos"
  },
  {
    "timeZone": "America/Argentina/Salta",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Salta"
  },
  {
    "timeZone": "America/Argentina/San_Juan",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "San_Juan"
  },
  {
    "timeZone": "America/Argentina/San_Luis",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "San_Luis"
  },
  {
    "timeZone": "America/Argentina/Tucuman",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Tucuman"
  },
  {
    "timeZone": "America/Argentina/Ushuaia",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AR",
    "country": "Argentina",
    "location": "Ushuaia"
  },
  {
    "timeZone": "America/Asuncion",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "PY",
    "country": "Paraguay",
    "location": "Asuncion"
  },
  {
    "timeZone": "America/Bahia",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Bahia"
  },
  {
    "timeZone": "America/Belem",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Belem"
  },
  {
    "timeZone": "America/Cayenne",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "GF",
    "country": "French Guiana",
    "location": "Cayenne"
  },
  {
    "timeZone": "America/Coyhaique",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "CL",
    "country": "Chile",
    "location": "Coyhaique"
  },
  {
    "timeZone": "America/Fortaleza",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Fortaleza"
  },
  {
    "timeZone": "America/Maceio",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Maceio"
  },
  {
    "timeZone": "America/Miquelon",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "PM",
    "country": "Saint Pierre and Miquelon",
    "location": "Miquelon"
  },
  {
    "timeZone": "America/Montevideo",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "UY",
    "country": "Uruguay",
    "location": "Montevideo"
  },
  {
    "timeZone": "America/Paramaribo",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "SR",
    "country": "Suriname",
    "location": "Paramaribo"
  },
  {
    "timeZone": "America/Punta_Arenas",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "CL",
    "country": "Chile",
    "location": "Punta_Arenas"
  },
  {
    "timeZone": "America/Recife",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Recife"
  },
  {
    "timeZone": "America/Santarem",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Santarem"
  },
  {
    "timeZone": "America/Santiago",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "CL",
    "country": "Chile",
    "location": "Santiago"
  },
  {
    "timeZone": "America/Sao_Paulo",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Sao_Paulo"
  },
  {
    "timeZone": "Antarctica/Palmer",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Palmer"
  },
  {
    "timeZone": "Antarctica/Rothera",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Rothera"
  },
  {
    "timeZone": "Atlantic/Stanley",
    "offsetDescription": "GMT-03:00",
    "offsetInText": "-03:00",
    "offsetInSeconds": -10800,
    "offsetInMinutes": -180,
    "countryIsoCode": "FK",
    "country": "Falkland Islands (Malvinas)",
    "location": "Stanley"
  },
  {
    "timeZone": "America/Noronha",
    "offsetDescription": "GMT-02:00",
    "offsetInText": "-02:00",
    "offsetInSeconds": -7200,
    "offsetInMinutes": -120,
    "countryIsoCode": "BR",
    "country": "Brazil",
    "location": "Noronha"
  },
  {
    "timeZone": "America/Nuuk",
    "offsetDescription": "GMT-02:00",
    "offsetInText": "-02:00",
    "offsetInSeconds": -7200,
    "offsetInMinutes": -120,
    "countryIsoCode": "GL",
    "country": "Greenland",
    "location": "Nuuk"
  },
  {
    "timeZone": "America/Scoresbysund",
    "offsetDescription": "GMT-02:00",
    "offsetInText": "-02:00",
    "offsetInSeconds": -7200,
    "offsetInMinutes": -120,
    "countryIsoCode": "GL",
    "country": "Greenland",
    "location": "Scoresbysund"
  },
  {
    "timeZone": "Atlantic/South_Georgia",
    "offsetDescription": "GMT-02:00",
    "offsetInText": "-02:00",
    "offsetInSeconds": -7200,
    "offsetInMinutes": -120,
    "countryIsoCode": "GS",
    "country": "South Georgia and the South Sandwich Islands",
    "location": "South_Georgia"
  },
  {
    "timeZone": "Atlantic/Azores",
    "offsetDescription": "GMT-01:00",
    "offsetInText": "-01:00",
    "offsetInSeconds": -3600,
    "offsetInMinutes": -60,
    "countryIsoCode": "PT",
    "country": "Portugal",
    "location": "Azores"
  },
  {
    "timeZone": "Atlantic/Cape_Verde",
    "offsetDescription": "GMT-01:00",
    "offsetInText": "-01:00",
    "offsetInSeconds": -3600,
    "offsetInMinutes": -60,
    "countryIsoCode": "CV",
    "country": "Cape Verde",
    "location": "Cape_Verde"
  },
  {
    "timeZone": "Africa/Abidjan",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "CI",
    "country": "Côte d'Ivoire",
    "location": "Abidjan"
  },
  {
    "timeZone": "Africa/Accra",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GH",
    "country": "Ghana",
    "location": "Accra"
  },
  {
    "timeZone": "Africa/Bamako",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "ML",
    "country": "Mali",
    "location": "Bamako"
  },
  {
    "timeZone": "Africa/Banjul",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GM",
    "country": "Gambia",
    "location": "Banjul"
  },
  {
    "timeZone": "Africa/Bissau",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GW",
    "country": "Guinea-Bissau",
    "location": "Bissau"
  },
  {
    "timeZone": "Africa/Conakry",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GN",
    "country": "Guinea",
    "location": "Conakry"
  },
  {
    "timeZone": "Africa/Dakar",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "SN",
    "country": "Senegal",
    "location": "Dakar"
  },
  {
    "timeZone": "Africa/Freetown",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "SL",
    "country": "Sierra Leone",
    "location": "Freetown"
  },
  {
    "timeZone": "Africa/Lome",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "TG",
    "country": "Togo",
    "location": "Lome"
  },
  {
    "timeZone": "Africa/Monrovia",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "LR",
    "country": "Liberia",
    "location": "Monrovia"
  },
  {
    "timeZone": "Africa/Nouakchott",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "MR",
    "country": "Mauritania",
    "location": "Nouakchott"
  },
  {
    "timeZone": "Africa/Ouagadougou",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "BF",
    "country": "Burkina Faso",
    "location": "Ouagadougou"
  },
  {
    "timeZone": "Africa/Sao_Tome",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "ST",
    "country": "Sao Tome and Principe",
    "location": "Sao_Tome"
  },
  {
    "timeZone": "America/Danmarkshavn",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GL",
    "country": "Greenland",
    "location": "Danmarkshavn"
  },
  {
    "timeZone": "Antarctica/Troll",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Troll"
  },
  {
    "timeZone": "Atlantic/Canary",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "ES",
    "country": "Spain",
    "location": "Canary"
  },
  {
    "timeZone": "Atlantic/Faroe",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "FO",
    "country": "Faroe Islands",
    "location": "Faroe"
  },
  {
    "timeZone": "Atlantic/Madeira",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "PT",
    "country": "Portugal",
    "location": "Madeira"
  },
  {
    "timeZone": "Atlantic/Reykjavik",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "IS",
    "country": "Iceland",
    "location": "Reykjavik"
  },
  {
    "timeZone": "Atlantic/St_Helena",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "SH",
    "country": "Saint Helena, Ascension and Tristan da Cunha",
    "location": "St_Helena"
  },
  {
    "timeZone": "Europe/Dublin",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "IE",
    "country": "Ireland",
    "location": "Dublin"
  },
  {
    "timeZone": "Europe/Guernsey",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GG",
    "country": "Guernsey",
    "location": "Guernsey"
  },
  {
    "timeZone": "Europe/Isle_of_Man",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "IM",
    "country": "Isle of Man",
    "location": "Isle_of_Man"
  },
  {
    "timeZone": "Europe/Jersey",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "JE",
    "country": "Jersey",
    "location": "Jersey"
  },
  {
    "timeZone": "Europe/Lisbon",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "PT",
    "country": "Portugal",
    "location": "Lisbon"
  },
  {
    "timeZone": "Europe/London",
    "offsetDescription": "GMT+00:00",
    "offsetInText": "+00:00",
    "offsetInSeconds": 0,
    "offsetInMinutes": 0,
    "countryIsoCode": "GB",
    "country": "United Kingdom",
    "location": "London"
  },
  {
    "timeZone": "Africa/Algiers",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "DZ",
    "country": "Algeria",
    "location": "Algiers"
  },
  {
    "timeZone": "Africa/Bangui",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CF",
    "country": "Central African Republic",
    "location": "Bangui"
  },
  {
    "timeZone": "Africa/Brazzaville",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CG",
    "country": "Congo",
    "location": "Brazzaville"
  },
  {
    "timeZone": "Africa/Casablanca",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "MA",
    "country": "Morocco",
    "location": "Casablanca"
  },
  {
    "timeZone": "Africa/Ceuta",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "ES",
    "country": "Spain",
    "location": "Ceuta"
  },
  {
    "timeZone": "Africa/Douala",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CM",
    "country": "Cameroon",
    "location": "Douala"
  },
  {
    "timeZone": "Africa/El_Aaiun",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "MA",
    "country": "Morocco",
    "location": "El_Aaiun"
  },
  {
    "timeZone": "Africa/Kinshasa",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CD",
    "country": "Congo, the Democratic Republic of the",
    "location": "Kinshasa"
  },
  {
    "timeZone": "Africa/Lagos",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "NG",
    "country": "Nigeria",
    "location": "Lagos"
  },
  {
    "timeZone": "Africa/Libreville",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "GA",
    "country": "Gabon",
    "location": "Libreville"
  },
  {
    "timeZone": "Africa/Luanda",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "AO",
    "country": "Angola",
    "location": "Luanda"
  },
  {
    "timeZone": "Africa/Malabo",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "GQ",
    "country": "Equatorial Guinea",
    "location": "Malabo"
  },
  {
    "timeZone": "Africa/Ndjamena",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "TD",
    "country": "Chad",
    "location": "Ndjamena"
  },
  {
    "timeZone": "Africa/Niamey",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "NE",
    "country": "Niger",
    "location": "Niamey"
  },
  {
    "timeZone": "Africa/Porto-Novo",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "BJ",
    "country": "Benin",
    "location": "Porto-Novo"
  },
  {
    "timeZone": "Africa/Tunis",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "TN",
    "country": "Tunisia",
    "location": "Tunis"
  },
  {
    "timeZone": "Arctic/Longyearbyen",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "SJ",
    "country": "Svalbard and Jan Mayen",
    "location": "Longyearbyen"
  },
  {
    "timeZone": "Europe/Amsterdam",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "NL",
    "country": "Netherlands",
    "location": "Amsterdam"
  },
  {
    "timeZone": "Europe/Andorra",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "AD",
    "country": "Andorra",
    "location": "Andorra"
  },
  {
    "timeZone": "Europe/Belgrade",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "RS",
    "country": "Serbia",
    "location": "Belgrade"
  },
  {
    "timeZone": "Europe/Berlin",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "DE",
    "country": "Germany",
    "location": "Berlin"
  },
  {
    "timeZone": "Europe/Bratislava",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "SK",
    "country": "Slovakia",
    "location": "Bratislava"
  },
  {
    "timeZone": "Europe/Brussels",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "BE",
    "country": "Belgium",
    "location": "Brussels"
  },
  {
    "timeZone": "Europe/Budapest",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "HU",
    "country": "Hungary",
    "location": "Budapest"
  },
  {
    "timeZone": "Europe/Busingen",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "DE",
    "country": "Germany",
    "location": "Busingen"
  },
  {
    "timeZone": "Europe/Copenhagen",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "DK",
    "country": "Denmark",
    "location": "Copenhagen"
  },
  {
    "timeZone": "Europe/Gibraltar",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "GI",
    "country": "Gibraltar",
    "location": "Gibraltar"
  },
  {
    "timeZone": "Europe/Ljubljana",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "SI",
    "country": "Slovenia",
    "location": "Ljubljana"
  },
  {
    "timeZone": "Europe/Luxembourg",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "LU",
    "country": "Luxembourg",
    "location": "Luxembourg"
  },
  {
    "timeZone": "Europe/Madrid",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "ES",
    "country": "Spain",
    "location": "Madrid"
  },
  {
    "timeZone": "Europe/Malta",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "MT",
    "country": "Malta",
    "location": "Malta"
  },
  {
    "timeZone": "Europe/Monaco",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "MC",
    "country": "Monaco",
    "location": "Monaco"
  },
  {
    "timeZone": "Europe/Oslo",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "NO",
    "country": "Norway",
    "location": "Oslo"
  },
  {
    "timeZone": "Europe/Paris",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "FR",
    "country": "France",
    "location": "Paris"
  },
  {
    "timeZone": "Europe/Podgorica",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "ME",
    "country": "Montenegro",
    "location": "Podgorica"
  },
  {
    "timeZone": "Europe/Prague",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CZ",
    "country": "Czech Republic",
    "location": "Prague"
  },
  {
    "timeZone": "Europe/Rome",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "IT",
    "country": "Italy",
    "location": "Rome"
  },
  {
    "timeZone": "Europe/San_Marino",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "SM",
    "country": "San Marino",
    "location": "San_Marino"
  },
  {
    "timeZone": "Europe/Sarajevo",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "BA",
    "country": "Bosnia and Herzegovina",
    "location": "Sarajevo"
  },
  {
    "timeZone": "Europe/Skopje",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "MK",
    "country": "Macedonia, the Former Yugoslav Republic of",
    "location": "Skopje"
  },
  {
    "timeZone": "Europe/Stockholm",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "SE",
    "country": "Sweden",
    "location": "Stockholm"
  },
  {
    "timeZone": "Europe/Tirane",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "AL",
    "country": "Albania",
    "location": "Tirane"
  },
  {
    "timeZone": "Europe/Vaduz",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "LI",
    "country": "Liechtenstein",
    "location": "Vaduz"
  },
  {
    "timeZone": "Europe/Vatican",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "VA",
    "country": "Holy See (Vatican City State)",
    "location": "Vatican"
  },
  {
    "timeZone": "Europe/Vienna",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "AT",
    "country": "Austria",
    "location": "Vienna"
  },
  {
    "timeZone": "Europe/Warsaw",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "PL",
    "country": "Poland",
    "location": "Warsaw"
  },
  {
    "timeZone": "Europe/Zagreb",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "HR",
    "country": "Croatia",
    "location": "Zagreb"
  },
  {
    "timeZone": "Europe/Zurich",
    "offsetDescription": "GMT+01:00",
    "offsetInText": "+01:00",
    "offsetInSeconds": 3600,
    "offsetInMinutes": 60,
    "countryIsoCode": "CH",
    "country": "Switzerland",
    "location": "Zurich"
  },
  {
    "timeZone": "Africa/Blantyre",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "MW",
    "country": "Malawi",
    "location": "Blantyre"
  },
  {
    "timeZone": "Africa/Bujumbura",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "BI",
    "country": "Burundi",
    "location": "Bujumbura"
  },
  {
    "timeZone": "Africa/Cairo",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "EG",
    "country": "Egypt",
    "location": "Cairo"
  },
  {
    "timeZone": "Africa/Gaborone",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "BW",
    "country": "Botswana",
    "location": "Gaborone"
  },
  {
    "timeZone": "Africa/Harare",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "ZW",
    "country": "Zimbabwe",
    "location": "Harare"
  },
  {
    "timeZone": "Africa/Johannesburg",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "ZA",
    "country": "South Africa",
    "location": "Johannesburg"
  },
  {
    "timeZone": "Africa/Juba",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "SS",
    "country": "South Sudan",
    "location": "Juba"
  },
  {
    "timeZone": "Africa/Khartoum",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "SD",
    "country": "Sudan",
    "location": "Khartoum"
  },
  {
    "timeZone": "Africa/Kigali",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "RW",
    "country": "Rwanda",
    "location": "Kigali"
  },
  {
    "timeZone": "Africa/Lubumbashi",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "CD",
    "country": "Congo, the Democratic Republic of the",
    "location": "Lubumbashi"
  },
  {
    "timeZone": "Africa/Lusaka",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "ZM",
    "country": "Zambia",
    "location": "Lusaka"
  },
  {
    "timeZone": "Africa/Maputo",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "MZ",
    "country": "Mozambique",
    "location": "Maputo"
  },
  {
    "timeZone": "Africa/Maseru",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "LS",
    "country": "Lesotho",
    "location": "Maseru"
  },
  {
    "timeZone": "Africa/Mbabane",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "SZ",
    "country": "Swaziland",
    "location": "Mbabane"
  },
  {
    "timeZone": "Africa/Tripoli",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "LY",
    "country": "Libya",
    "location": "Tripoli"
  },
  {
    "timeZone": "Africa/Windhoek",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "NA",
    "country": "Namibia",
    "location": "Windhoek"
  },
  {
    "timeZone": "Asia/Beirut",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "LB",
    "country": "Lebanon",
    "location": "Beirut"
  },
  {
    "timeZone": "Asia/Famagusta",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "CY",
    "country": "Cyprus",
    "location": "Famagusta"
  },
  {
    "timeZone": "Asia/Gaza",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "PS",
    "country": "Palestine, State of",
    "location": "Gaza"
  },
  {
    "timeZone": "Asia/Hebron",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "PS",
    "country": "Palestine, State of",
    "location": "Hebron"
  },
  {
    "timeZone": "Asia/Jerusalem",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "IL",
    "country": "Israel",
    "location": "Jerusalem"
  },
  {
    "timeZone": "Asia/Nicosia",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "CY",
    "country": "Cyprus",
    "location": "Nicosia"
  },
  {
    "timeZone": "Europe/Athens",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "GR",
    "country": "Greece",
    "location": "Athens"
  },
  {
    "timeZone": "Europe/Bucharest",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "RO",
    "country": "Romania",
    "location": "Bucharest"
  },
  {
    "timeZone": "Europe/Chisinau",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "MD",
    "country": "Moldova, Republic of",
    "location": "Chisinau"
  },
  {
    "timeZone": "Europe/Helsinki",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "FI",
    "country": "Finland",
    "location": "Helsinki"
  },
  {
    "timeZone": "Europe/Kaliningrad",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Kaliningrad"
  },
  {
    "timeZone": "Europe/Kyiv",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "UA",
    "country": "Ukraine",
    "location": "Kyiv"
  },
  {
    "timeZone": "Europe/Mariehamn",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "AX",
    "country": "Åland Islands",
    "location": "Mariehamn"
  },
  {
    "timeZone": "Europe/Riga",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "LV",
    "country": "Latvia",
    "location": "Riga"
  },
  {
    "timeZone": "Europe/Sofia",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "BG",
    "country": "Bulgaria",
    "location": "Sofia"
  },
  {
    "timeZone": "Europe/Tallinn",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "EE",
    "country": "Estonia",
    "location": "Tallinn"
  },
  {
    "timeZone": "Europe/Vilnius",
    "offsetDescription": "GMT+02:00",
    "offsetInText": "+02:00",
    "offsetInSeconds": 7200,
    "offsetInMinutes": 120,
    "countryIsoCode": "LT",
    "country": "Lithuania",
    "location": "Vilnius"
  },
  {
    "timeZone": "Africa/Addis_Ababa",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "ET",
    "country": "Ethiopia",
    "location": "Addis_Ababa"
  },
  {
    "timeZone": "Africa/Asmara",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "ER",
    "country": "Eritrea",
    "location": "Asmara"
  },
  {
    "timeZone": "Africa/Dar_es_Salaam",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "TZ",
    "country": "Tanzania, United Republic of",
    "location": "Dar_es_Salaam"
  },
  {
    "timeZone": "Africa/Djibouti",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "DJ",
    "country": "Djibouti",
    "location": "Djibouti"
  },
  {
    "timeZone": "Africa/Kampala",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "UG",
    "country": "Uganda",
    "location": "Kampala"
  },
  {
    "timeZone": "Africa/Mogadishu",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "SO",
    "country": "Somalia",
    "location": "Mogadishu"
  },
  {
    "timeZone": "Africa/Nairobi",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "KE",
    "country": "Kenya",
    "location": "Nairobi"
  },
  {
    "timeZone": "Antarctica/Syowa",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Syowa"
  },
  {
    "timeZone": "Asia/Aden",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "YE",
    "country": "Yemen",
    "location": "Aden"
  },
  {
    "timeZone": "Asia/Amman",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "JO",
    "country": "Jordan",
    "location": "Amman"
  },
  {
    "timeZone": "Asia/Baghdad",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "IQ",
    "country": "Iraq",
    "location": "Baghdad"
  },
  {
    "timeZone": "Asia/Bahrain",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "BH",
    "country": "Bahrain",
    "location": "Bahrain"
  },
  {
    "timeZone": "Asia/Damascus",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "SY",
    "country": "Syrian Arab Republic",
    "location": "Damascus"
  },
  {
    "timeZone": "Asia/Kuwait",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "KW",
    "country": "Kuwait",
    "location": "Kuwait"
  },
  {
    "timeZone": "Asia/Qatar",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "QA",
    "country": "Qatar",
    "location": "Qatar"
  },
  {
    "timeZone": "Asia/Riyadh",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "SA",
    "country": "Saudi Arabia",
    "location": "Riyadh"
  },
  {
    "timeZone": "Europe/Istanbul",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "TR",
    "country": "Turkey",
    "location": "Istanbul"
  },
  {
    "timeZone": "Europe/Kirov",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Kirov"
  },
  {
    "timeZone": "Europe/Minsk",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "BY",
    "country": "Belarus",
    "location": "Minsk"
  },
  {
    "timeZone": "Europe/Moscow",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Moscow"
  },
  {
    "timeZone": "Europe/Simferopol",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "UA",
    "country": "Ukraine",
    "location": "Simferopol"
  },
  {
    "timeZone": "Europe/Volgograd",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Volgograd"
  },
  {
    "timeZone": "Indian/Antananarivo",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "MG",
    "country": "Madagascar",
    "location": "Antananarivo"
  },
  {
    "timeZone": "Indian/Comoro",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "KM",
    "country": "Comoros",
    "location": "Comoro"
  },
  {
    "timeZone": "Indian/Mayotte",
    "offsetDescription": "GMT+03:00",
    "offsetInText": "+03:00",
    "offsetInSeconds": 10800,
    "offsetInMinutes": 180,
    "countryIsoCode": "YT",
    "country": "Mayotte",
    "location": "Mayotte"
  },
  {
    "timeZone": "Asia/Tehran",
    "offsetDescription": "GMT+03:30",
    "offsetInText": "+03:30",
    "offsetInSeconds": 12600,
    "offsetInMinutes": 210,
    "countryIsoCode": "IR",
    "country": "Iran, Islamic Republic of",
    "location": "Tehran"
  },
  {
    "timeZone": "Asia/Baku",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "AZ",
    "country": "Azerbaijan",
    "location": "Baku"
  },
  {
    "timeZone": "Asia/Dubai",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "AE",
    "country": "United Arab Emirates",
    "location": "Dubai"
  },
  {
    "timeZone": "Asia/Muscat",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "OM",
    "country": "Oman",
    "location": "Muscat"
  },
  {
    "timeZone": "Asia/Tbilisi",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "GE",
    "country": "Georgia",
    "location": "Tbilisi"
  },
  {
    "timeZone": "Asia/Yerevan",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "AM",
    "country": "Armenia",
    "location": "Yerevan"
  },
  {
    "timeZone": "Europe/Astrakhan",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Astrakhan"
  },
  {
    "timeZone": "Europe/Samara",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Samara"
  },
  {
    "timeZone": "Europe/Saratov",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Saratov"
  },
  {
    "timeZone": "Europe/Ulyanovsk",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Ulyanovsk"
  },
  {
    "timeZone": "Indian/Mahe",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "SC",
    "country": "Seychelles",
    "location": "Mahe"
  },
  {
    "timeZone": "Indian/Mauritius",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "MU",
    "country": "Mauritius",
    "location": "Mauritius"
  },
  {
    "timeZone": "Indian/Reunion",
    "offsetDescription": "GMT+04:00",
    "offsetInText": "+04:00",
    "offsetInSeconds": 14400,
    "offsetInMinutes": 240,
    "countryIsoCode": "RE",
    "country": "Réunion",
    "location": "Reunion"
  },
  {
    "timeZone": "Asia/Kabul",
    "offsetDescription": "GMT+04:30",
    "offsetInText": "+04:30",
    "offsetInSeconds": 16200,
    "offsetInMinutes": 270,
    "countryIsoCode": "AF",
    "country": "Afghanistan",
    "location": "Kabul"
  },
  {
    "timeZone": "Antarctica/Mawson",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Mawson"
  },
  {
    "timeZone": "Antarctica/Vostok",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Vostok"
  },
  {
    "timeZone": "Asia/Almaty",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Almaty"
  },
  {
    "timeZone": "Asia/Aqtau",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Aqtau"
  },
  {
    "timeZone": "Asia/Aqtobe",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Aqtobe"
  },
  {
    "timeZone": "Asia/Ashgabat",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "TM",
    "country": "Turkmenistan",
    "location": "Ashgabat"
  },
  {
    "timeZone": "Asia/Atyrau",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Atyrau"
  },
  {
    "timeZone": "Asia/Dushanbe",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "TJ",
    "country": "Tajikistan",
    "location": "Dushanbe"
  },
  {
    "timeZone": "Asia/Karachi",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "PK",
    "country": "Pakistan",
    "location": "Karachi"
  },
  {
    "timeZone": "Asia/Oral",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Oral"
  },
  {
    "timeZone": "Asia/Qostanay",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Qostanay"
  },
  {
    "timeZone": "Asia/Qyzylorda",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "KZ",
    "country": "Kazakhstan",
    "location": "Qyzylorda"
  },
  {
    "timeZone": "Asia/Samarkand",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "UZ",
    "country": "Uzbekistan",
    "location": "Samarkand"
  },
  {
    "timeZone": "Asia/Tashkent",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "UZ",
    "country": "Uzbekistan",
    "location": "Tashkent"
  },
  {
    "timeZone": "Asia/Yekaterinburg",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Yekaterinburg"
  },
  {
    "timeZone": "Indian/Kerguelen",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "TF",
    "country": "French Southern Territories",
    "location": "Kerguelen"
  },
  {
    "timeZone": "Indian/Maldives",
    "offsetDescription": "GMT+05:00",
    "offsetInText": "+05:00",
    "offsetInSeconds": 18000,
    "offsetInMinutes": 300,
    "countryIsoCode": "MV",
    "country": "Maldives",
    "location": "Maldives"
  },
  {
    "timeZone": "Asia/Colombo",
    "offsetDescription": "GMT+05:30",
    "offsetInText": "+05:30",
    "offsetInSeconds": 19800,
    "offsetInMinutes": 330,
    "countryIsoCode": "LK",
    "country": "Sri Lanka",
    "location": "Colombo"
  },
  {
    "timeZone": "Asia/Kolkata",
    "offsetDescription": "GMT+05:30",
    "offsetInText": "+05:30",
    "offsetInSeconds": 19800,
    "offsetInMinutes": 330,
    "countryIsoCode": "IN",
    "country": "India",
    "location": "Kolkata"
  },
  {
    "timeZone": "Asia/Kathmandu",
    "offsetDescription": "GMT+05:45",
    "offsetInText": "+05:45",
    "offsetInSeconds": 20700,
    "offsetInMinutes": 345,
    "countryIsoCode": "NP",
    "country": "Nepal",
    "location": "Kathmandu"
  },
  {
    "timeZone": "Asia/Bishkek",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "KG",
    "country": "Kyrgyzstan",
    "location": "Bishkek"
  },
  {
    "timeZone": "Asia/Dhaka",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "BD",
    "country": "Bangladesh",
    "location": "Dhaka"
  },
  {
    "timeZone": "Asia/Omsk",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Omsk"
  },
  {
    "timeZone": "Asia/Thimphu",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "BT",
    "country": "Bhutan",
    "location": "Thimphu"
  },
  {
    "timeZone": "Asia/Urumqi",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "CN",
    "country": "China",
    "location": "Urumqi"
  },
  {
    "timeZone": "Indian/Chagos",
    "offsetDescription": "GMT+06:00",
    "offsetInText": "+06:00",
    "offsetInSeconds": 21600,
    "offsetInMinutes": 360,
    "countryIsoCode": "IO",
    "country": "British Indian Ocean Territory",
    "location": "Chagos"
  },
  {
    "timeZone": "Asia/Yangon",
    "offsetDescription": "GMT+06:30",
    "offsetInText": "+06:30",
    "offsetInSeconds": 23400,
    "offsetInMinutes": 390,
    "countryIsoCode": "MM",
    "country": "Myanmar",
    "location": "Yangon"
  },
  {
    "timeZone": "Indian/Cocos",
    "offsetDescription": "GMT+06:30",
    "offsetInText": "+06:30",
    "offsetInSeconds": 23400,
    "offsetInMinutes": 390,
    "countryIsoCode": "CC",
    "country": "Cocos (Keeling) Islands",
    "location": "Cocos"
  },
  {
    "timeZone": "Antarctica/Davis",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Davis"
  },
  {
    "timeZone": "Asia/Bangkok",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "TH",
    "country": "Thailand",
    "location": "Bangkok"
  },
  {
    "timeZone": "Asia/Barnaul",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Barnaul"
  },
  {
    "timeZone": "Asia/Ho_Chi_Minh",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "VN",
    "country": "Viet Nam",
    "location": "Ho_Chi_Minh"
  },
  {
    "timeZone": "Asia/Hovd",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "MN",
    "country": "Mongolia",
    "location": "Hovd"
  },
  {
    "timeZone": "Asia/Jakarta",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "ID",
    "country": "Indonesia",
    "location": "Jakarta"
  },
  {
    "timeZone": "Asia/Krasnoyarsk",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Krasnoyarsk"
  },
  {
    "timeZone": "Asia/Novokuznetsk",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Novokuznetsk"
  },
  {
    "timeZone": "Asia/Novosibirsk",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Novosibirsk"
  },
  {
    "timeZone": "Asia/Phnom_Penh",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "KH",
    "country": "Cambodia",
    "location": "Phnom_Penh"
  },
  {
    "timeZone": "Asia/Pontianak",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "ID",
    "country": "Indonesia",
    "location": "Pontianak"
  },
  {
    "timeZone": "Asia/Tomsk",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Tomsk"
  },
  {
    "timeZone": "Asia/Vientiane",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "LA",
    "country": "Lao People's Democratic Republic",
    "location": "Vientiane"
  },
  {
    "timeZone": "Indian/Christmas",
    "offsetDescription": "GMT+07:00",
    "offsetInText": "+07:00",
    "offsetInSeconds": 25200,
    "offsetInMinutes": 420,
    "countryIsoCode": "CX",
    "country": "Christmas Island",
    "location": "Christmas"
  },
  {
    "timeZone": "Antarctica/Casey",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "Casey"
  },
  {
    "timeZone": "Asia/Brunei",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "BN",
    "country": "Brunei Darussalam",
    "location": "Brunei"
  },
  {
    "timeZone": "Asia/Hong_Kong",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "HK",
    "country": "Hong Kong",
    "location": "Hong_Kong"
  },
  {
    "timeZone": "Asia/Irkutsk",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Irkutsk"
  },
  {
    "timeZone": "Asia/Kuala_Lumpur",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "MY",
    "country": "Malaysia",
    "location": "Kuala_Lumpur"
  },
  {
    "timeZone": "Asia/Kuching",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "MY",
    "country": "Malaysia",
    "location": "Kuching"
  },
  {
    "timeZone": "Asia/Macau",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "MO",
    "country": "Macao",
    "location": "Macau"
  },
  {
    "timeZone": "Asia/Makassar",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "ID",
    "country": "Indonesia",
    "location": "Makassar"
  },
  {
    "timeZone": "Asia/Manila",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "PH",
    "country": "Philippines",
    "location": "Manila"
  },
  {
    "timeZone": "Asia/Shanghai",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "CN",
    "country": "China",
    "location": "Shanghai"
  },
  {
    "timeZone": "Asia/Singapore",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "SG",
    "country": "Singapore",
    "location": "Singapore"
  },
  {
    "timeZone": "Asia/Taipei",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "TW",
    "country": "Taiwan, Province of China",
    "location": "Taipei"
  },
  {
    "timeZone": "Asia/Ulaanbaatar",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "MN",
    "country": "Mongolia",
    "location": "Ulaanbaatar"
  },
  {
    "timeZone": "Australia/Perth",
    "offsetDescription": "GMT+08:00",
    "offsetInText": "+08:00",
    "offsetInSeconds": 28800,
    "offsetInMinutes": 480,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Perth"
  },
  {
    "timeZone": "Australia/Eucla",
    "offsetDescription": "GMT+08:45",
    "offsetInText": "+08:45",
    "offsetInSeconds": 31500,
    "offsetInMinutes": 525,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Eucla"
  },
  {
    "timeZone": "Asia/Chita",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Chita"
  },
  {
    "timeZone": "Asia/Dili",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "TL",
    "country": "Timor-Leste",
    "location": "Dili"
  },
  {
    "timeZone": "Asia/Jayapura",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "ID",
    "country": "Indonesia",
    "location": "Jayapura"
  },
  {
    "timeZone": "Asia/Khandyga",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Khandyga"
  },
  {
    "timeZone": "Asia/Pyongyang",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "KP",
    "country": "Korea, Democratic People's Republic of",
    "location": "Pyongyang"
  },
  {
    "timeZone": "Asia/Seoul",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "KR",
    "country": "Korea, Republic of",
    "location": "Seoul"
  },
  {
    "timeZone": "Asia/Tokyo",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "JP",
    "country": "Japan",
    "location": "Tokyo"
  },
  {
    "timeZone": "Asia/Yakutsk",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Yakutsk"
  },
  {
    "timeZone": "Pacific/Palau",
    "offsetDescription": "GMT+09:00",
    "offsetInText": "+09:00",
    "offsetInSeconds": 32400,
    "offsetInMinutes": 540,
    "countryIsoCode": "PW",
    "country": "Palau",
    "location": "Palau"
  },
  {
    "timeZone": "Australia/Darwin",
    "offsetDescription": "GMT+09:30",
    "offsetInText": "+09:30",
    "offsetInSeconds": 34200,
    "offsetInMinutes": 570,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Darwin"
  },
  {
    "timeZone": "Antarctica/DumontDUrville",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "DumontDUrville"
  },
  {
    "timeZone": "Asia/Ust-Nera",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Ust-Nera"
  },
  {
    "timeZone": "Asia/Vladivostok",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Vladivostok"
  },
  {
    "timeZone": "Australia/Brisbane",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Brisbane"
  },
  {
    "timeZone": "Australia/Lindeman",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Lindeman"
  },
  {
    "timeZone": "Pacific/Chuuk",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "FM",
    "country": "Micronesia, Federated States of",
    "location": "Chuuk"
  },
  {
    "timeZone": "Pacific/Guam",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "GU",
    "country": "Guam",
    "location": "Guam"
  },
  {
    "timeZone": "Pacific/Port_Moresby",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "PG",
    "country": "Papua New Guinea",
    "location": "Port_Moresby"
  },
  {
    "timeZone": "Pacific/Saipan",
    "offsetDescription": "GMT+10:00",
    "offsetInText": "+10:00",
    "offsetInSeconds": 36000,
    "offsetInMinutes": 600,
    "countryIsoCode": "MP",
    "country": "Northern Mariana Islands",
    "location": "Saipan"
  },
  {
    "timeZone": "Australia/Adelaide",
    "offsetDescription": "GMT+10:30",
    "offsetInText": "+10:30",
    "offsetInSeconds": 37800,
    "offsetInMinutes": 630,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Adelaide"
  },
  {
    "timeZone": "Australia/Broken_Hill",
    "offsetDescription": "GMT+10:30",
    "offsetInText": "+10:30",
    "offsetInSeconds": 37800,
    "offsetInMinutes": 630,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Broken_Hill"
  },
  {
    "timeZone": "Antarctica/Macquarie",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Macquarie"
  },
  {
    "timeZone": "Asia/Magadan",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Magadan"
  },
  {
    "timeZone": "Asia/Sakhalin",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Sakhalin"
  },
  {
    "timeZone": "Asia/Srednekolymsk",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Srednekolymsk"
  },
  {
    "timeZone": "Australia/Hobart",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Hobart"
  },
  {
    "timeZone": "Australia/Lord_Howe",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Lord_Howe"
  },
  {
    "timeZone": "Australia/Melbourne",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Melbourne"
  },
  {
    "timeZone": "Australia/Sydney",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "AU",
    "country": "Australia",
    "location": "Sydney"
  },
  {
    "timeZone": "Pacific/Bougainville",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "PG",
    "country": "Papua New Guinea",
    "location": "Bougainville"
  },
  {
    "timeZone": "Pacific/Efate",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "VU",
    "country": "Vanuatu",
    "location": "Efate"
  },
  {
    "timeZone": "Pacific/Guadalcanal",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "SB",
    "country": "Solomon Islands",
    "location": "Guadalcanal"
  },
  {
    "timeZone": "Pacific/Kosrae",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "FM",
    "country": "Micronesia, Federated States of",
    "location": "Kosrae"
  },
  {
    "timeZone": "Pacific/Noumea",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "NC",
    "country": "New Caledonia",
    "location": "Noumea"
  },
  {
    "timeZone": "Pacific/Pohnpei",
    "offsetDescription": "GMT+11:00",
    "offsetInText": "+11:00",
    "offsetInSeconds": 39600,
    "offsetInMinutes": 660,
    "countryIsoCode": "FM",
    "country": "Micronesia, Federated States of",
    "location": "Pohnpei"
  },
  {
    "timeZone": "Asia/Anadyr",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Anadyr"
  },
  {
    "timeZone": "Asia/Kamchatka",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "RU",
    "country": "Russian Federation",
    "location": "Kamchatka"
  },
  {
    "timeZone": "Pacific/Fiji",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "FJ",
    "country": "Fiji",
    "location": "Fiji"
  },
  {
    "timeZone": "Pacific/Funafuti",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "TV",
    "country": "Tuvalu",
    "location": "Funafuti"
  },
  {
    "timeZone": "Pacific/Kwajalein",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "MH",
    "country": "Marshall Islands",
    "location": "Kwajalein"
  },
  {
    "timeZone": "Pacific/Majuro",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "MH",
    "country": "Marshall Islands",
    "location": "Majuro"
  },
  {
    "timeZone": "Pacific/Nauru",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "NR",
    "country": "Nauru",
    "location": "Nauru"
  },
  {
    "timeZone": "Pacific/Norfolk",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "NF",
    "country": "Norfolk Island",
    "location": "Norfolk"
  },
  {
    "timeZone": "Pacific/Tarawa",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "KI",
    "country": "Kiribati",
    "location": "Tarawa"
  },
  {
    "timeZone": "Pacific/Wake",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "UM",
    "country": "United States Minor Outlying Islands",
    "location": "Wake"
  },
  {
    "timeZone": "Pacific/Wallis",
    "offsetDescription": "GMT+12:00",
    "offsetInText": "+12:00",
    "offsetInSeconds": 43200,
    "offsetInMinutes": 720,
    "countryIsoCode": "WF",
    "country": "Wallis and Futuna",
    "location": "Wallis"
  },
  {
    "timeZone": "Antarctica/McMurdo",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "AQ",
    "country": "Antarctica",
    "location": "McMurdo"
  },
  {
    "timeZone": "Pacific/Apia",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "WS",
    "country": "Samoa",
    "location": "Apia"
  },
  {
    "timeZone": "Pacific/Auckland",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "NZ",
    "country": "New Zealand",
    "location": "Auckland"
  },
  {
    "timeZone": "Pacific/Fakaofo",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "TK",
    "country": "Tokelau",
    "location": "Fakaofo"
  },
  {
    "timeZone": "Pacific/Kanton",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "KI",
    "country": "Kiribati",
    "location": "Kanton"
  },
  {
    "timeZone": "Pacific/Tongatapu",
    "offsetDescription": "GMT+13:00",
    "offsetInText": "+13:00",
    "offsetInSeconds": 46800,
    "offsetInMinutes": 780,
    "countryIsoCode": "TO",
    "country": "Tonga",
    "location": "Tongatapu"
  },
  {
    "timeZone": "Pacific/Chatham",
    "offsetDescription": "GMT+13:45",
    "offsetInText": "+13:45",
    "offsetInSeconds": 49500,
    "offsetInMinutes": 825,
    "countryIsoCode": "NZ",
    "country": "New Zealand",
    "location": "Chatham"
  },
  {
    "timeZone": "Pacific/Kiritimati",
    "offsetDescription": "GMT+14:00",
    "offsetInText": "+14:00",
    "offsetInSeconds": 50400,
    "offsetInMinutes": 840,
    "countryIsoCode": "KI",
    "country": "Kiribati",
    "location": "Kiritimati"
  }
]